import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 32, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function KineticWords({ lines, delay = 0.15 }) {
  return (
    <>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.14em] -mb-[0.14em]">
          <motion.span
            className="block"
            initial={{ y: "115%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.9, delay: delay + i * 0.16, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </>
  );
}

export function Kicker({ children, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      <span className="h-px w-8 bg-[#B89759]/70" />
      <span className="kicker">{children}</span>
    </span>
  );
}

export function SectionHead({ kicker, title, copy, dark = false, center = false }) {
  return (
    <Reveal className={center ? "text-center" : ""}>
      <Kicker className={center ? "justify-center" : ""}>{kicker}</Kicker>
      <h2
        className={`mt-5 font-serif text-3xl sm:text-4xl font-normal tracking-tight ${
          dark ? "text-[#FAF7F2]" : "text-[#1C1815]"
        }`}
      >
        {title}
      </h2>
      {copy && (
        <p
          className={`mt-5 max-w-2xl text-base font-light leading-relaxed ${
            dark ? "text-[#B7AA99]" : "text-[#4A423A]"
          } ${center ? "mx-auto" : ""}`}
        >
          {copy}
        </p>
      )}
    </Reveal>
  );
}
